/* eslint-disable vue/no-mutating-props */
<template>
  <section>
    <b-alert v-show="!empresa.is_digital_signature" show dismissible fade variant="success">Assinatural Digital não esta
      habilita pra seu usuário, para mais
      informações entre em contato com o suporte do sistema.</b-alert>
    <b-tabs>
      <b-tab title="Dados Pessoais">
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Nome" label-for="input-1">
              <b-form-input id="input-1" v-model="objectAgronomo.nome" type="text" placeholder="Informe seu nome"
                required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="CPF" label-for="input-2">
              <b-form-input id="input-2" v-model="objectAgronomo.cpf" v-mask="['###.###.###-##']" type="text"
                placeholder="Informe seu CPF" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Profissão" label-for="input-4">
              <b-form-input id="input-4" v-model="objectAgronomo.profissao" type="text"
                placeholder="Informe sua profissão" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-3" label="CREA ou CFTA" label-for="input-3">
              <b-form-input id="input-3" v-model="objectAgronomo.crea" type="text" placeholder="Informe seu CREA ou CFTA"
                required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-button type="submit" variant="primary" @click.prevent="salvarAgronomo">Salvar</b-button>
      </b-tab>
      <b-tab title="Dados do Endereço">
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-7" label="CEP" label-for="input-7">
              <b-row no-gutters>
                <b-col cols="9" class="pr-2">
                  <b-form-input id="input-5" v-model="objectAgronomo.cep" v-mask="['#####-###']" type="text"
                    placeholder="Informe seu CEP" required></b-form-input>
                </b-col>
                <b-col cols="3">
                  <b-button type="button" variant="primary" @click.prevent="procurarCEP">Buscar</b-button>
                </b-col>
              </b-row>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="Endereço" label-for="input-6">
              <b-form-input id="input-6" v-model="objectAgronomo.logradouro" type="text"
                placeholder="Informe seu Endereço" required></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-3" label="Número" label-for="input-7">
              <b-form-input id="input-7" v-model="objectAgronomo.numero" type="text"
                placeholder="Informe o número do seu endereço" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="Complemento" label-for="input-8">
              <b-form-input id="input-8" v-model="objectAgronomo.complemento" type="text"
                placeholder="Informe o complemento" required></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-9" label="Estado" label-for="">
              <select v-model="objectAgronomo.id_estado" class="form-control">
                <option v-if="agronomoEstado !== null" value="" selected>{{
                  agronomoEstado
                }}</option>
                <option v-for="estado of estados" :key="estado.id_estado" :value="estado.id_estado">{{ estado.nome }}
                </option>
              </select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-9" label="Cidade" label-for="">
              <select v-model="objectAgronomo.ibge" class="form-control" aria-placeholder="">
                <option v-if="agronomoCidade !== null" value="" selected>{{
                  agronomoCidade
                }}</option>
                <option v-for="cidade of cidades" :key="cidade.ibge" :value="cidade.ibge">{{ cidade.nome }}
                </option>
              </select>
            </b-form-group>
          </div>
        </div>
        <b-button type="submit" variant="primary" @click.prevent="salvarAgronomo">Salvar</b-button>
      </b-tab>
      <b-tab title="Númeração da Receita">
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="ART" label-for="input-15">
              <b-form-input id="input-15" v-model="objectAgronomo.art_primaria" type="text" placeholder="Informe sua ART"
                required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="Número de Receitas Por ART" label-for="input-9">
              <b-form-input id="input-9" v-model="objectAgronomo.n_receitas_art" type="text"
                placeholder="Informe o nº de receitas por ART" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label-for="input-customer-name">
              <template v-slot:label>
                Complemento do número
                <b-icon v-b-tooltip.hover role="button"
                  title="O campo deve ser preenchido para complementar o número da receita ex: BR202203RA"
                  icon="exclamation-circle-fill" variant="info"></b-icon>
              </template>
              <input id="input-impressao" v-model="objectAgronomo.art_impressao" v-no-autocomplete type="text"
                class="form-control" placeholder="Complemento do número" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="Última Receita Emitida" label-for="input-12">
              <b-form-input id="input-12" v-model="objectAgronomo.ultima_receita" type="text"
                placeholder="Informe qual foi a última receita emitida" required></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-button type="submit" variant="primary" @click.prevent="salvarAgronomo">Salvar</b-button>
      </b-tab>
      <b-tab title="Assinatura Digital" :disabled="!empresa.is_digital_signature" @click="checkPermissinDigitalSignature">
        <div class="row">
          <div class="w-50">
            <b-tabs v-model="tabIndex" pills vertical>
              <b-tab title="Certificado Digital" active>
                <div class="row">
                  <div class="col-md-8">
                    <b-form-group id="input-file-digital" label="Certificado digital" label-for="iinput-file-digital">
                      <b-form-file v-model="file" placeholder="Selecione seu arquivo do certificado digital"
                        drop-placeholder="Drop file here..." browse-text="Selecionar" accept=".pfx"></b-form-file>
                    </b-form-group>
                  </div>
                  <div class="col-md-12"></div>
                  <div class="col-md-6">
                    <b-form-group id="input-passowrd-digital-signature" label="Senha do certificado"
                      label-for="input-passowrd-digital-signature">
                      <b-form-input id="input-passowrd-digital-signatured" v-model="textPasswordFile" v-no-autocomplete
                        name="password" type="password" placeholder="Senha do certificado" required>
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-2 mt-4 pt-1">
                    <b-button type="submit" variant="primary" @click="uploadCert">Enviar</b-button>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Texto">
                <b-form-group id="input-digital-signature" label="Nome" label-for="input-digital-signature">
                  <b-form-input id="input-digital-signature" v-model="textDataSignature" class="sig3" type="text"
                    placeholder="Digite seu nome" required></b-form-input>
                </b-form-group>
              </b-tab>
              <b-tab title="Desenhar">
                <div class="col-12">
                  Assinatura
                  <VueSignaturePad id="signature" ref="signaturePad" width="100%" height="100px" :options="{
                    onBegin: () => {
                      $refs.signaturePad.resizeCanvas()
                    },
                  }" />
                </div>
              </b-tab>
            </b-tabs>
            <div v-show="tabIndex == 1 || tabIndex == 2" class="buttons mt-3 text-center">
              <button class="btn btn-primary mr-3" @click="save">Salvar Assinatura</button>
              <button class="btn btn-primary" @click="undo">Limpar</button>
            </div>
          </div>
          <div v-show="(imgDataSignature != undefined && imgDataSignature.length > 0) ||
            (textDataSignature != undefined && textDataSignature.length > 0)
            " class="col-5 ml-5 pl-5 mt-3">
            <label>Aparência da Assinatura no Receituário</label>
            <footer class="footer-receita">
              <div class="card">
                <img v-if="imgDataSignature != undefined && imgDataSignature.length > 0
                  " height="40" :src="imgDataSignature" alt="assinatura" />
                <label v-else class="sig3 mt-2">{{ textDataSignature }}</label>
                <div class="assinatura">
                  <p>{{ objectAgronomo.nome }}</p>
                </div>
                <div class="card-footer-receita mt-2 mb-2">
                  <div>
                    <p>
                      <b>Título do profissional:</b>
                      {{ objectAgronomo.profissao }}
                    </p>
                    <p> <b>CPF: </b>{{ objectAgronomo.cpf }} </p>

                    <p> <b>CREA:</b>{{ objectAgronomo.crea }} </p>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </b-tab>
      <b-tab title="Configurações Adicionais">
        <div class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-3" label="Nº Cópias Impressão Receituário" label-for="input-12">
              <b-form-input id="input-12" v-model="objectAgronomo.n_copias" type="number"
                placeholder="Informe o nº de cópias para impressão" required></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-12"></div>
          <div class="mb-2">
            <div class="col-md-12">
              <b-form-checkbox v-model="objectAgronomo.is_sign_prod">
                Não mostrar a assinatura do produtor
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <b-button type="submit" variant="primary" @click.prevent="salvarAgronomo">Salvar</b-button>
      </b-tab>
    </b-tabs>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </section>
</template>
<script>
import { mask } from 'vue-the-mask'
import estadoServices from '@/src/services/estado'
import Loading from 'vue-loading-overlay'
import agronomoService from '@/src/services/agronomo'
import empresaService from '@/src/services/empresa_sistema'
import CEPService from "@/src/services/cep";

export default {
  name: 'FormAgronomo',
  components: {
    Loading,
  },
  directives: { mask },
  props: {
    agronomo: {},
  },
  data() {
    return {
      empresa: {},
      options: {
        penColor: '#000',
        minWidth: 0.5,
        maxWidth: 6,
      },
      file: '',
      imgDataSignature: '',
      textDataSignature: '',
      textPasswordFile: '',
      objectAgronomo: {},
      agronomoEstado: '',
      agronomoCidade: '',
      estados: [],
      cidades: [],
      estadoSelecionado: '',
      cidadeSelecionada: '',
      isLoading: true,
      modal: {
        show: false,
        sucesso: false,
        erro: {},
      },
      tabIndex: 0,
    }
  },
  watch: {
    'objectAgronomo.id_estado'() {
      this.listaCidade(this.objectAgronomo.id_estado)
      this.loading(this.isLoading)
    },
    cidadeSelecionada() {
      this.objectAgronomo.ibge = this.cidadeSelecionada.ibge
    },
  },

  mounted() {
    this.listaEstados()
    this.estadoId()
    this.selecionaMunicipio()
    this.objectAgronomo = {
      id_agronomo: this.agronomo.id_agronomo,
      nome: this.agronomo.nome,
      cpf: this.agronomo.cpf,
      crea: this.agronomo.crea,
      profissao: this.agronomo.profissao,
      cep: this.agronomo.cep,
      logradouro: this.agronomo.logradouro,
      numero: this.agronomo.numero,
      complemento: this.agronomo.complemento,
      id_estado: this.agronomo.id_estado,
      id_municipio: this.agronomo.id_municipio,
      ibge: '',
      n_receitas_art: this.agronomo.n_receitas_art,
      n_receitas_mes: this.agronomo.n_receitas_mes,
      ultima_receita: this.agronomo.ultima_receita,
      ativo: this.agronomo.ativo,
      busca_art: this.agronomo.busca_art,
      art_primaria: this.agronomo.art_primaria,
      art_secundaria: this.agronomo.art_secundaria,
      formato_receita: this.agronomo.formato_receita,
      n_copias: this.agronomo.n_copias,
      id_empresa_sistema: this.agronomo.id_empresa_sistema,
      data_cadastro: this.agronomo.data_cadastro,
      data_atualizacao: this.agronomo.data_atualizacao,
      login: this.agronomo.login,
      senha: this.agronomo.senha,
      receita_art_disponivel: this.agronomo.receita_art_disponivel,
      art_impressao: this.agronomo.art_impressao,
      registro_sc: this.agronomo.registro_sc,
      registro_empresa_sc: this.agronomo.registro_empresa_sc,
      is_sign_prod: this.agronomo.is_sign_prod,
    }
    this.textDataSignature = this.objectAgronomo.nome
    this.getEmpresa()
  },
  methods: {
    findAddress(cep) {
      CEPService.find(cep)
        .then(response => {
          if (response.erro) {
            this.$bvToast.toast('CEP não encontrado. Por favor, verifique e tente novamente.', {
              variant: 'danger',
              solid: true,
              noCloseButton: false,
              toaster: 'b-toaster-top-center',
            });
            return;
          }

          this.objectAgronomo.logradouro = response.logradouro;
          this.objectAgronomo.complemento = response.complemento;

          let state = this.estados.find(i => i.nome === response.state);
          this.objectAgronomo.id_estado = state ? state.id_estado : "";

          setTimeout(() => {
            let city = this.cidades.find(i => i.nome === response.localidade);
            this.objectAgronomo.ibge = city ? city.ibge : "";
          }, 1500);
        })
        .catch(error => {
          let mensagemErro = 'Erro ao buscar o endereço. Por favor, tente novamente.';
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message.join(', ');
          }

          this.$bvToast.toast(mensagemErro, {
            variant: 'danger',
            solid: true,
            noCloseButton: false,
            toaster: 'b-toaster-top-center',
          });
        });
    },
    procurarCEP() {
      const cep = this.objectAgronomo.cep;
      if (cep && cep.length >= 5) {
        this.findAddress(cep);
      }
    },
    uploadCert() {
      if (this.textPasswordFile.length == 0) {
        this.$bvToast.toast('Senha do arquivo é obrigatório', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }
      let dataForm = new FormData()
      dataForm.append('cert', this.file)
      dataForm.append('id', this.agronomo.id_agronomo)
      dataForm.append('password', this.textPasswordFile)

      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      agronomoService
        .uploadDigitalCert(token, dataForm)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast(
            'Certificado registrado na plataforma WebReceita!',
            {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
    getEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
      })
    },
    undo() {
      if (this.tabIndex == 0) {
        this.textDataSignature = ''
        return
      }
      this.$refs.signaturePad.clearSignature()
      this.imgDataSignature = ''
    },
    save() {
      if (this.tabIndex == 0) {
        this.imgDataSignature = ''
      }
      if (this.tabIndex == 1) {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
        this.imgDataSignature = data
      }

      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      agronomoService
        .atualizarAssinaturaDigital(
          token,
          this.objectAgronomo.id_agronomo,
          this.imgDataSignature != undefined && this.imgDataSignature.length > 0
            ? this.imgDataSignature
            : this.textDataSignature
        )
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Assinatura Digital Atualizada!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
    estadoId() {
      const token = this.$store.state.auth.currentUser.token
      estadoServices
        .idEstado(token, this.objectAgronomo.id_estado)
        .then((resposta) => {
          this.estadoSelecionado = this.produtorEstado
        })
    },
    selecionaMunicipio() {
      if (this.objectAgronomo.id_municipio) {
        const token = this.$store.state.auth.currentUser.token
        estadoServices
          .municipio(token, this.objectAgronomo.id_municipio)
          .then((resposta) => {
            this.objectAgronomo.ibge = Number(resposta.data.ibge)
            this.listaCidade(this.objectAgronomo.id_estado)
          })
      }
    },
    lista() {
      for (const estado of this.estados) {
        if (estado.id_estado == this.agronomo.id_estado) {
          this.agronomoEstado = estado.nome
        }
      }
      for (const cidade of this.cidades) {
        if (cidade.id_municipio == this.agronomo.id_municipio) {
          this.agronomoCidade = cidade.nome
        }
      }
    },
    loading(a) {
      a = !this.isLoading
      return a
    },
    listaEstados() {
      const token = this.$store.state.auth.currentUser.token
      estadoServices.lista(token).then((resposta) => {
        this.estados = resposta.data.estados
        this.isLoading = this.loading(this.isLoading)
        this.listaCidade(this.agronomo.id_estado)
      })
    },
    listaCidade(a) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      estadoServices.listaCidades(token, a).then((resposta) => {
        this.cidades = resposta.data.cidades
        this.isLoading = this.loading(this.isLoading)
        this.lista()
      })
    },
    salvarAgronomo() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      if (this.agronomo.id_agronomo) {
        agronomoService
          .atualizarAgronomo(token, this.objectAgronomo)
          .then((resposta) => {
            this.$bvToast.toast('Atualizado com sucesso!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
      } else {
        agronomoService
          .salvar(token, this.objectAgronomo)
          .then((resposta) => {
            this.isLoading = this.loading(this.isLoading)
            if (!resposta.data.sucesso) {
              this.$bvToast.toast(resposta.data.aviso.mensagem, {
                variant: 'danger',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
            } else {
              this.$bvToast.toast('Salvo com sucesso!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })

              this.objectAgronomo = {}
            }
          })
          .catch((erro) => {
            this.$bvToast.toast(erro.response.data.message.join(', '), {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            this.isLoading = this.loading(this.isLoading)
          })
      }
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Dancing+Script');

.sig3 {
  font-family: 'Dancing Script';
  font-size: 1.9em;
}

#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
  z-index: 1000;
}

.footer-receita .card {
  border: 2px solid #000;
  width: 60%;
  text-align: center;
  font-size: 9px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.footer-receita .card:nth-of-type(1) {
  margin-right: 3%;
}

.assinatura {
  width: 90%;
  height: 10px;
  margin: auto;
  border-bottom: 2px solid black;
  position: relative;
  flex-grow: 1;
}

.assinatura p {
  padding: 0;
  margin: 0;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  bottom: -20px;
}

.card-footer-receita {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-right: 10px;
}

.card-footer-receita div {
  margin-top: 15px;
  text-align: left;
  padding: 0 5px;
}

.card-footer-receita p {
  margin: 0;
  padding: 0;
}
</style>